import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';
import { ModuleType } from '../../../../types/modules';
import {
  getModuleData,
  getModuleDataByModuleType,
} from '../../../selectors/modules';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../selectors/users';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { actions as ModalActions } from '@wix/da-shared-react/pkg/Modals';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';

export default connect(
  (state: AppState, ownProps) => {
    const moduleData = getModuleData(state, ownProps.moduleId);
    const pinnedDeviationId = getModuleDataByModuleType(
      state,
      ModuleType.FEED_PINNED_DEVIATION
    ).itemId;

    const { results, hasMore } = moduleData;
    const items = getDeviationsByIds(state, results).filter(
      deviation => !deviation.isDeleted
    );
    return {
      items,
      pinnedDeviationId,
      hasMore,
      isEmpty: !items.length,
      profileOwnerUser: getProfileOwnerUser(state),
      isOwner: isCurrentUserProfileOwner(state),
    };
  },
  (dispatch, ownProps) => ({
    openSubmitPostPopup: () =>
      dispatch(
        ModalActions.pushModal(ModalType.STATUS_UPDATE, { wrapInPopup: false })
      ),
  })
);
